module.exports = __webpack_public_path__ + "static/media/explore-more-icon-3.1cc8c6a1.svg";